import { Box, Typography, Button, Container } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          py: 8
        }}
      >
        <Typography variant="h1" component="h1" color="primary" sx={{ fontWeight: 700, fontSize: { xs: '4rem', md: '6rem' } }}>
          404
        </Typography>

        <Typography variant="h4" component="h2" color="textSecondary" sx={{ mt: 2, mb: 4 }}>
          Strona nie została znaleziona
        </Typography>

        <Typography variant="body1" color="textSecondary" sx={{ mb: 4, maxWidth: '600px' }}>
          Przepraszamy, ale strona, której szukasz, nie istnieje. Być może adres URL został zmieniony, usunięty lub jest tymczasowo niedostępny.
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/')}
          sx={{ mt: 2 }}
        >
          Wróć do strony głównej
        </Button>
      </Box>
    </Container>
  )
}

export default NotFound